<template>
    <v-row>
        <v-col cols="12" class="title-label">
            {{ $t('coach.professional_info') }}
        </v-col>
        <v-col cols="12">
            <kimsa-textarea-field
                :label="$t('entrance.description')"
                :placeholder="$t('entrance.description_placeholder')"
                :rules="rules.description"
                @change="description = $event"
                :value="description"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-text-field
                input-mode="numeric"
                :label="$t('entrance.experience')"
                :placeholder="$t('entrance.experience_placeholder')"
                @change="experience = $event"
                :value="experience"
                :max-length="2"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-combobox
                :label="$t('entrance.sport_areas')"
                :placeholder="sport_placeholder"
                :items="sports"
                @change="sport_areas = $event"
                :value-array="sport_areas"
                withInfo multiple
                ref="sport"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-textarea-field
                :label="$t('entrance.professional_preparation')"
                :placeholder="$t('entrance.professional_preparation_placeholder')"
                @change="professional_preparation = $event"
                :value="professional_preparation"
            />
        </v-col>
    </v-row>
</template>

<script>

import KimsaTextareaField from '@/components/common/inputs/KimsaTextareaField'
import KimsaTextField from '@/components/common/inputs/KimsaTextField'
import KimsaCombobox from '@/components/common/inputs/KimsaCombobox'

import {mapActions, mapState} from 'vuex'
import {debounce} from "@/utils/Common";

export default {
    components: {
        KimsaTextareaField,
        KimsaTextField,
        KimsaCombobox,
    },
    props: {
        stepperMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            description: '',
            experience: null,
            sport_areas: [],
            professional_preparation: '',
        }
    },
    computed: {
        ...mapState(['config']),
        sport_placeholder(vm = this) {
            if (vm.sport_areas.length === 0) return vm.$t('entrance.sport_areas_placeholder')
            return vm.$tc('common.quantity_selected', vm.sport_areas.length, {quantity: vm.sport_areas.length})
        },
        sports(vm = this) {
            if (!vm.config) return []
            return vm.config.sports.map(sport => ({name: sport, value: sport}))
        },
        form(vm = this) {
            return {
                description: vm.description,
                experience: vm.experience,
                sport_areas: vm.sport_areas,
                professional_preparation: vm.professional_preparation,
            }
        },
        rules(vm = this) {
            return {
                description: [v => v && v.length >= 4 || vm.$t('rules.min_length', {num: '4'})]
            }
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.setDefaults()
    },
    methods: {
        ...mapActions(['bindConfig']),
        setDefaults() {
            const vm = this
            vm.description = vm.account?.description || ''
            vm.experience = vm.account?.experience || null
            vm.sport_areas = vm.account?.sport_areas?.map(s => ({name: s, value: s})) || []
            vm.$refs.sport.array = vm.sport_areas
            vm.professional_preparation = vm.account?.professional_preparation || ''
        },
        debouncedEmit: debounce(
            function () {
                this.$emit('change', this.form)
            }, 1000),
    },
    watch: {
        account() {
            if (!this.stepperMode) this.setDefaults()
        },
        form() {
            this.debouncedEmit()
        },
    },
}
</script>

<style scoped>

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}

</style>